import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
    padding-inline: 20px;
`;

export const ContainerContent = styled.div`
    display: flex;
    width: 45.681px;
    height: 210px;
    background: transparent;
    @media (orientation: landscape) and (max-width: 1200px){
        width: 45.681px;
        height: 180px;
    }
`;

export const Bar = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 20.375px;
    height: 210px;
    background: #E9E9E9;
    border-radius: 50px;
    @media (orientation: landscape) and (max-width: 1200px) {
        height: 180px;
    }
`;

export const BarFill = styled.div`
    display: flex;
    position: relative;
    align-items: flex-end;
    width: 7.951px;
    height: 190px;
    background: #fff;
    border-radius: 50px;
    @media (orientation: landscape) and (max-width: 1200px) {
        height: 160px;
    }
`;

export const BarContent = styled.div`
    width: 7.951px;
    height: ${props => (props.$value)+'%'};
    background: ${props => (props.color)};
    border-radius: 50px;
`;

export const MarcIndicator = styled.div`
    position: absolute;
    background:  ${props=> (props.$color)};
    width: ${props=> (props.$width)};
    height: 3px;
    z-index: 999;
    bottom: ${props=> (props.$position)+'%'};
    left: ${props=> (props.$left)};
    border-radius: 10px;
`;

export const MarcBall = styled.div`
    display: flex;
    scale: 2.2;
    position: absolute;
    background:  ${props=> (props.$color)};
    left: ${props=> (props.$left)};
    height: 3px;
    width: 3px;
    z-index: 1000;
    bottom: ${props=> (props.$position)+'%'};
    border-radius: 50%;
`

export const MarcText = styled.h1`
    position: absolute;
    bottom: ${props=> (props.$position)+'%'};
    left: ${props=> (props.$left)};
    height: 3px;
    color: ${props=> (props.$color)};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 0px; /* 0% */
    top: -10px;
    z-index: 1001;
`;

export const BallContainer =styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 4px;
    bottom: ${props => (props.$value)+'%'};
    z-index: 1000;
`;

export const Ball = styled.div`
    position: absolute;
    background: #D9D9D9;
    width: 45px;
    height: 45px;
    border-radius: 50%;
`;

export const BallColor = styled.div`
    position: absolute;
    background: ${props => (props.color)};
    width: 23px;
    height: 23px;
    border-radius: 50%;
`;